import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";

import { ECHARTS_COLORS as COLORS } from '../../constants/echarts-colors.constants';

const CustomEchartLegend = ({ chartRef, dataset }) => {
  const [legendItems, setLegendItems] = useState();

  function supressSelection(index) {
    const chart = chartRef?.current?.getEchartsInstance();

    const visualMap = chart?.getOption().visualMap[0];
    const selected = visualMap.selected;

    selected[index] = !selected[index];

    chart.dispatchAction({
      type: 'selectDataRange',
      selected,
    })

    setLegendItems(selected)
  }

  return (
    <>
      <div className="ps-lg-5 ps-xl-6 pe-xl-5 d-none d-lg-flex flex-column">
        <Row className="mb-3">
          <Col className="d-flex flex-column gap-1">
            {dataset.slice(0, 5).map((item, index) => (
              <LegendItem key={index} item={item} index={index} onClick={(index) => supressSelection(index)} legendItems={legendItems} />
            ))}
          </Col>
        </Row>
        <Row className="border-top border-gray pt-4">
          <Col className="d-flex flex-column gap-1">
            {dataset.slice(5, 10).map((item, index) => (
              <LegendItem key={index} item={item} index={index + 5} onClick={(index) => supressSelection(index)} legendItems={legendItems} />
            ))}
          </Col>
          <Col className="d-flex flex-column gap-1">
            {dataset.slice(10).map((item, index) => (
              <LegendItem key={index} item={item} index={index + 10} onClick={(index) => supressSelection(index)} legendItems={legendItems} />
            ))}
          </Col>
        </Row>
      </div>
      <div className="d-flex flex-wrap d-lg-none gap-2">
        {dataset.map((item, index) => (
          <LegendItem key={index} item={item} index={index} onClick={(index) => supressSelection(index)} legendItems={legendItems} />
        ))}
      </div>
    </>
  );
}


const LegendItem = ({ item, index, legendItems, onClick }) => {
  return (
    <div key={index} className="d-flex align-items-center gap-2 mb-1 legend-item text-muted" onClick={() => onClick(index)}>
      <div className="legend-circle d-flex align-items-center justify-content-center" style={{ backgroundColor: COLORS[index] }} >{index + 1}</div>
      <div className={legendItems && !legendItems[index] ? "deselected" : ""}>{item[3]}</div>
    </div>
  );
}
export default CustomEchartLegend;
